//JS 与 客户端通用处理
// var app = parseInt(vars.client);
var judgeClient = function(){
	var u = navigator.userAgent,
	 app = navigator.appVersion;
	if(u.indexOf('Android') > -1){
		return 1;
	}else if(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
		return 2;
	}else{
		return 3;
	}
};
//client_id=>平台类型 1为安卓 2为ios 3为pc
var client_id = judgeClient();
if ( client_id == 2) {
//IOS
;(function() {
	if (window.WebViewJavascriptBridge) { return }
	var messagingIframe;
	var sendMessageQueue = [];

	var CUSTOM_PROTOCOL_SCHEME = 'action';
	var QUEUE_HAS_MESSAGE = 'Send2OC';


	function _createQueueReadyIframe(doc) {
		messagingIframe = doc.createElement('iframe');
		messagingIframe.style.display = 'none';
		doc.documentElement.appendChild(messagingIframe);
	}

	function init(messageHandler) {
		if (WebViewJavascriptBridge._fetchQueue) { throw new Error('WebViewJavascriptBridge.init called twice'); }
	}

	function send(data) {
		sendMessageQueue.push({data:data});
		messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE;
	}

	function _fetchQueue() {
		var messageQueueString = JSON.stringify(sendMessageQueue);
		sendMessageQueue = [];
		return messageQueueString;
	}

	window.WebViewJavascriptBridge = {
		init: init,
		send: send,
		_fetchQueue: _fetchQueue
	};

	var doc = document;
	_createQueueReadyIframe(doc);
	var readyEvent = doc.createEvent('Events');
	readyEvent.initEvent('WebViewJavascriptBridgeReady');
	readyEvent.bridge = WebViewJavascriptBridge;
	doc.dispatchEvent(readyEvent);
	})();

};///end if

/**
 * js与客户端交互
 */
var _js2Client = function( json_str ){
	if(client_id == 1){
		console.log("is_andriod");
		if( window['df_interface'] ){
			window.df_interface.sendData( json_str );
		}else{
			return false;
		}
	}else if( client_id == 2 ){//IOS
		console.log('76行',"is_ios");
		if( window.WebViewJavascriptBridge ){
			window.WebViewJavascriptBridge.send( json_str );
		}
		return false;
	}else if( client_id == 3 ){//PC
		try{
			sendData(json_str);
		}catch(err){
			return false;
		}
	}
}

// exports._js2Client = _js2Client;
export default  _js2Client